import * as api from '@gitbook/api-client';
import { Icon } from '@gitbook/spine-icons';
import {
    Button,
    Description,
    EmptyState,
    EmptyStateActions,
    EmptyStateIcon,
} from '@gitbook/spine-react';

/**
 * Blankslate when the change request has no edit yet.
 */
export function ChangeRequestNoChanges(props: {
    space: api.Space;
    changeRequest: api.ChangeRequest;
}) {
    const { space, changeRequest } = props;
    return (
        <div className="rounded border">
            {changeRequest.createdBy.id === api.GitBookUsers.GitbookAgent ? (
                <EmptyState>
                    <EmptyStateIcon>
                        <Icon.AIAgentAnimated state="loading" />
                    </EmptyStateIcon>
                    <Description>
                        The GitBook Agent is working on this change request. Changes will appear
                        here as they are made.
                    </Description>
                    <EmptyStateActions>
                        <Button
                            leadingIcon={Icon.AIMakeLonger}
                            label="View logs"
                            kind="secondary"
                            href={{
                                current: {
                                    sideSheet: {
                                        type: 'agent',
                                    },
                                },
                            }}
                        />
                    </EmptyStateActions>
                </EmptyState>
            ) : (
                <EmptyState>
                    <EmptyStateIcon>
                        <Icon.AddPageGroup />
                    </EmptyStateIcon>
                    <Description>No pages have been edited yet in this change request</Description>
                    {space.permissions.edit &&
                    changeRequest.status !== api.ChangeRequestStatus.Archived &&
                    changeRequest.status !== api.ChangeRequestStatus.Merged ? (
                        <EmptyStateActions>
                            <Button
                                leadingIcon={Icon.Edit}
                                label="Edit change request"
                                kind="secondary"
                                href={{
                                    screen: {
                                        type: 'space',
                                        organization: space.organization,
                                        space: space.id,
                                        changeRequest: changeRequest.number,
                                        revision: undefined,
                                        page: '',
                                        mode: 'edit',
                                    },
                                }}
                            />
                        </EmptyStateActions>
                    ) : null}
                </EmptyState>
            )}
        </div>
    );
}
